import type { ReactNode } from "react";

// Data-dense table primitive for the admin UI. ink-700 hairlines,
// hover state, header in monospace caps. Columns are JSX so callers
// can render badges / icons inline. Rows accept an optional onClick.
export function Table({ children }: { children: ReactNode }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">{children}</table>
    </div>
  );
}

export function THead({ children }: { children: ReactNode }) {
  return (
    <thead className="border-b border-ink-700">
      <tr>{children}</tr>
    </thead>
  );
}

export function TH({ children }: { children?: ReactNode }) {
  return (
    <th className="text-left font-mono text-[10px] uppercase tracking-widest text-ink-400 py-2 px-3">
      {children}
    </th>
  );
}

export function TBody({ children }: { children: ReactNode }) {
  return <tbody>{children}</tbody>;
}

export function TR({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) {
  return (
    <tr
      className={`border-b border-ink-800 ${onClick ? "cursor-pointer hover:bg-ink-900/40" : ""} transition-colors`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TD({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <td className={`py-2.5 px-3 ${className ?? ""}`}>{children}</td>;
}
